import { join } from 'node:path';
import { z } from 'zod';
import { getGitIgnoredFolder } from '@wix/velo-github-layout-definitions';

export const SENTRY_DSN =
  'https://d15bb47ad34c428f92d0ac434a5734eb@o37417.ingest.sentry.io/4504116669317120';
export const WIX_CONFIG_FILENAME = 'wix.config.json';
export const TS_CONFIG_FILENAME = 'tsconfig.json';
export const WIX_LOCK_FILENAME = 'wix.lock';
export const VERSION_CACHE_FILENAME = 'version.cache.json';
export const USER_CONFIG_FILENAME = 'user.config.json';

export const userConfigSchema = z.object({
  telemetry: z.boolean().default(true),
  tunneling: z.boolean().default(false),
});

export type UserConfig = z.infer<typeof userConfigSchema>;

export function getWixConfigFilePath(projectFolder: string) {
  return join(projectFolder, WIX_CONFIG_FILENAME);
}

export function getTSConfigFilePath(projectFolder: string) {
  return join(projectFolder, TS_CONFIG_FILENAME);
}

export function getDebugLogFilePath(projectFolder: string) {
  return join(getGitIgnoredFolder(projectFolder), 'debug.log');
}

export function getUserFeedbackCacheFilePath(projectFolder: string) {
  return join(getGitIgnoredFolder(projectFolder), 'user-feedback.cache.json');
}

export function getWixLockFilePath(projectFolder: string) {
  return join(projectFolder, WIX_LOCK_FILENAME);
}
